export default __webpack_public_path__ + "static/media/Archive.927fe28c.svg";